export const BUSINESS = {
  name: "Patolas",
  full: "Patolas Banhos e Tosquias",
  rating: "4,8",
  reviewCount: 105,
  tagline: "Banhos, tosquias e grooming para animais de estimação",
  location: "Fernão Ferro",
  address: "Rua António Sérgio A56, 2865-053 Fernão Ferro, Portugal",
  phoneDisplay: "+351 930 631 829",
  phoneRaw: "351930631829",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_patudos-style/artifacts/8nbiq0jn_e5845e0e544e60e413ad62874b07741c.png",
  heroPhoto: "https://customer-assets-agu9un31.emergentagent.net/job_patudos-style/artifacts/nco1d3nw_Screenshot_2026-07-23-16-46-22-83_1c337646f29875672b5a61192b9010f9.jpg",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Rua+Ant%C3%B3nio+S%C3%A9rgio+A56+2865-053+Fern%C3%A3o+Ferro+Portugal",
  instagram: "https://www.instagram.com/patolasbanhostosquias",
  facebook: "https://www.facebook.com/share/1DCBQaEYju/",
};

export const WHATSAPP_LINK = `https://wa.me/${BUSINESS.phoneRaw}?text=${encodeURIComponent(
  "Olá Patolas! Gostaria de marcar um banho/tosquia para o meu patudo."
)}`;

export function fmtDatePt(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("pt-PT", {
      weekday: "long", day: "2-digit", month: "long", year: "numeric",
    });
  } catch {
    return iso;
  }
}

export const HOURS = [
  { day: "Segunda", time: "09:00 — 19:00" },
  { day: "Terça", time: "09:00 — 19:00" },
  { day: "Quarta", time: "09:00 — 19:00" },
  { day: "Quinta", time: "09:00 — 19:00" },
  { day: "Sexta", time: "09:00 — 19:00" },
  { day: "Sábado", time: "09:00 — 14:00" },
  { day: "Domingo", time: "Encerrado", closed: true },
];

export const SERVICES = [
  {
    n: "01",
    title: "Banhos",
    desc: "Banho completo com produtos hipoalergénicos, secagem cuidada e escovagem. O seu patudo sai macio, limpo e a cheirar bem.",
  },
  {
    n: "02",
    title: "Tosquias",
    desc: "Tosquia à medida de cada raça e feitio. Cortes higiénicos ou estéticos, sempre com paciência e respeito pelo animal.",
  },
  {
    n: "03",
    title: "Grooming",
    desc: "Corte de unhas, limpeza de ouvidos e cuidados de estética. Tratamento VIP para cães e gatos com muito carinho.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Cuidado",
    desc: "Cada animal é tratado como se fosse nosso. Atenção ao detalhe, produtos de qualidade e um espaço seguro e tranquilo.",
  },
  {
    n: "02",
    title: "Afeto",
    desc: "Os patudos sentem o carinho. Trabalhamos com calma e dedicação para que a visita seja sempre uma boa experiência.",
  },
  {
    n: "03",
    title: "Profissionalismo",
    desc: "Anos de experiência, horário marcado e resultados que falam por si. Recomendados por mais de uma centena de famílias.",
  },
];

export const REVIEWS = [
  {
    name: "Bryan Martins",
    when: "há 2 meses",
    stars: 5,
    text: "One word: Amazing. The employees are compassionate and truly love what they do. Our little guy can be a pain, but somehow they always manage.",
  },
  {
    name: "Naya",
    when: "há 10 meses",
    stars: 5,
    text: "Eu amo de paixão o carinho que têm pelo meu bebé e como o deixam ainda mais lindo. Obrigada Bruno pelo capricho, sou cliente há mais de um ano.",
  },
  {
    name: "Maria Margarida Rodrigues",
    when: "há 4 meses",
    stars: 5,
    text: "Foi a primeira vez que fomos ao espaço com a nossa Maggie... adorámos, ficámos clientes. Profissionalismo do princípio ao fim.",
  },
  {
    name: "Ana Maria Santana",
    when: "há 3 meses",
    stars: 5,
    text: "Excelente atendimento. Super atenciosos com os patudos. Tratam os animais com muito carinho. Excelentes profissionais no corte e no banho.",
  },
  {
    name: "Ana Margarida",
    when: "há 3 semanas",
    stars: 5,
    text: "Trabalho perfeito, simpatia com os animais! Recomendo a todos!",
  },
  {
    name: "Carla Baptista",
    when: "há 2 anos",
    stars: 5,
    text: "Uma equipa fora de série, fantástica a todos os níveis. Ainda só fui uma vez e já são família. Excelente trabalho e profissionalismo.",
  },
  {
    name: "Ana Cristina Gonçalves",
    when: "há um ano",
    stars: 5,
    text: "A minha Bali tem tratamento VIP, sai sempre como uma Diva. Bons profissionais, muito carinhosos. Recomendo a todos os patudos.",
  },
  {
    name: "Sacha Gonçalves",
    when: "há 2 anos",
    stars: 5,
    text: "Os meus cães parecem novos quando saem daqui. Tratamento VIP e eles sentem. Adoro o trabalho, dedicação e carinho.",
  },
  {
    name: "Rita Gouveia",
    when: "há 5 anos",
    stars: 5,
    text: "Adorei a experiência! E a minha cadelinha também (ficou LINDA). A Anabela é um doce de pessoa e trata os meninos com muito carinho.",
  },
  {
    name: "Eduardo Mourinho",
    when: "há 2 anos",
    stars: 5,
    text: "Excelente serviço. O meu Bax, pastor alemão, fica sempre mais novo e cheiroso.",
  },
  {
    name: "Leonardo Figueiroa",
    when: "há 2 anos",
    stars: 5,
    text: "Anabela é sem dúvidas a melhor da região! A nossa cadela volta sempre feliz e cheirosa.",
  },
  {
    name: "Diogo",
    when: "há 2 anos",
    stars: 5,
    text: "Atendem com horário marcado, são atenciosos e os pets gostam. Muito bom.",
  },
  {
    name: "Sofia Azevedo",
    when: "há 3 anos",
    stars: 4,
    text: "Gosto bastante, é onde levo a minha pequena sempre. Volta sempre com o pêlo macio e super cheirosa.",
  },
  {
    name: "Vera Castelo Branco",
    when: "há 6 anos",
    stars: 5,
    text: "Local de eleição para o banho do meu patudo. Extrema simpatia com os donos e muito afeto com os animais.",
  },
];
